import React from 'react'
import { Button, Table } from 'react-bootstrap'
import { Edit, Trash } from 'react-feather'

const FixedSourceList = ({ fixedSourceData, handleEdit, handleDelete }) => {
    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Title</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {fixedSourceData.map((sour, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td style={{textTransform:'capitalize'}}>{sour.title}</td>
                            <td>
                                <div className="d-flex gap-2">
                                     <Button variant='warning' size='sm' onClick={() => handleEdit(sour)}><Edit size={14} /></Button>
                                    {/* <Button variant='danger' size='sm' onClick={() => handleDelete(index)}><Trash size={14}/></Button> */}
                                </div>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

        </>
    )
}

export default FixedSourceList
